import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {MomentModule} from 'ngx-moment';

import {TeamPlanningModule} from '../+mss/team-planning/team-planning.module';
import {AuthenticationGuard} from '../shared/authentication';
import {ChartsModule} from '../shared/charts/charts.module';
import {RouteGuard} from '../shared/authentication/roles/route-guard';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {TeamsSharedModule} from '../shared/teams/teams-shared.module';
import {UiModule} from '../shared/ui/ui.module';
import {WorkflowV2Module} from '../shared/workflow/workflow-v2.module';

import {WorkflowStepStatusComponent} from './shared/workflow-step-status/workflow-step-status.component';
import {WorkflowTimelineComponent} from './shared/workflow-timeline/workflow-timeline.component';
import {WorkflowsAdminComponent} from './workflows-admin.component';

const routes: Routes = [
  {
    path: 'admin',
    component: WorkflowsAdminComponent,
    canActivate: [AuthenticationGuard, RouteGuard]
  }
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MomentModule,
    TranslateModule,
    FormsModule,
    UiModule,
    PipesModule,
    ModalModule,
    TeamsSharedModule,
    TeamPlanningModule,
    WorkflowV2Module,
    RouterModule.forChild(routes),
    ChartsModule
  ],
  exports: [
    WorkflowsAdminComponent
  ],
  declarations: [
    WorkflowStepStatusComponent,
    WorkflowTimelineComponent,
    WorkflowsAdminComponent
  ]
})
export class WorkflowsModule {
}
